'use strict';

//Require Modules
var Backbone = require('backbone'),
  mediator = require('../../js/mediator'),
  config = require('../../js/config'),
  ProductPricingService = require('../../services/ProductPricingService').default,
  globalisation = require('../../utilities/globalisation');

let ProductPricingView = Backbone.View.extend({
  initialize: function() {
    // Store some require data
    this.partId = String(this.$el.data('part-id')) || '';
    this.partNumber = this.$el.data('sku') || '';
    this.manufacturer = this.$el.data('manufacturer') || '';

    // Get elements
    this.$stock = this.$('.ProductPricing-stock');
    this.$stockContainer = this.$stock.parent();
    this.$buyingOption = this.$('.ProductPricing-buyingOption');
    this.$pricing = this.$('.ProductPricing-range');
    this.$costingUnit = this.$('.ProductPricing-costingUnit');
    this.$loading = this.$('.ProductPricing-loading');
    this.$hidden = this.$('.ProductPricing-hide');
    this.$pdfLink = this.$('.productDetailPdfDownload');
    if (this.$pdfLink.hasClass('disablePdf')) {
      this.$pdfLink.removeClass('disablePdf');
    }
    mediator.on(config.events.pricing.received, this.onPricingReceived, this);
  },

  onPricingReceived: function(parts) {
    // Check we are the same part
    let part = ProductPricingService.findBuyingOption(parts, this.partId, this.partNumber, this.manufacturer);

    if (part) {
      // Remove the event handler as it is no longer needed
      mediator.off(config.events.pricing.received, this.onPricingReceived, this);

      let isDiscontinued = part.isDiscontinued || false;
      this.updateViewWithPricingData(part.buyingOptions[0], isDiscontinued);
    }
  },

  setButtonForBuyingOption: function(buyingOption) {
    var buttonText = '';
    var buttonClass = 'Button--bordered';

    this.$buyingOption.removeClass('Button--red Button--bordered');

    switch (buyingOption.type) {
      case 'AddToCart':
        buttonText = globalisation.pluraliseAndTranslate('product', 'view');
        buttonClass = 'Button--red';
        break;

      case 'Backorder':
        buttonText = globalisation.pluraliseAndTranslate('shoppingCart', 'quoteOrder');
        break;

      case 'Verical':
        buttonText = globalisation.pluraliseAndTranslate('shoppingCart', 'vericalOrderButton');
        break;

      case 'Ecliptek':
        buttonText = globalisation.pluraliseAndTranslate('shoppingCart', 'ecliptekOrderButton');
        break;

      case 'Quote':
        buttonText = globalisation.pluraliseAndTranslate('shoppingCart', 'quoteOrderButton');
        if (!(buyingOption.lowestDisplayPrice && buyingOption.highestDisplayPrice)) {
          this.$pdfLink.addClass('disablePdf');
          this.$pdfLink.css({'background-color': '#757575'});
        }
        break;

      default:
        if (!(buyingOption.lowestDisplayPrice && buyingOption.highestDisplayPrice)) {
          this.$pdfLink.addClass('disablePdf');
          this.$pdfLink.css({'background-color': '#757575'});
        }
        break;
    }

    if (!(buyingOption.lowestDisplayPrice && buyingOption.highestDisplayPrice) && this.$pdfLink && this.$pdfLink.hasClass('disablePdf')) {
      this.$pdfLink.css({'background-color': '#757575'});
      this.$pdfLink.attr('tabindex', '-1');
    }

    // Update button
    if (buttonText) {
      this.$buyingOption.text(buttonText);
      this.$buyingOption.addClass(buttonClass);
      let buttonType = this.$('.DoubleCtas-item a');
      if (buttonType.length) {
        if (buttonText === 'Quote') {
          this.$('.DoubleCtas-item a')[0].setAttribute('aria-label','Request a ' + buttonText + ' on ' + this.$('.DoubleCtas-item a')[0].getAttribute('name'));
        }
        else {
          this.$('.DoubleCtas-item a')[0].setAttribute('aria-label',buttonText + ' ' + this.$('.DoubleCtas-item a')[0].getAttribute('name') + ' ' + this.$('.DoubleCtas-item a')[0].getAttribute('stklabel'));
        }
      }
    }
    this.$('.DoubleCtas').find('li.quote').removeClass('u-hide');
  },

  setPricingForBuyingOption: function(buyingOption) {
    var priceRange = 0;
    var showPricing = false;

    if (buyingOption.type === 'AddToCart' || buyingOption.type === 'Backorder') {
      priceRange = buyingOption.lowestDisplayPrice;
      showPricing = !!priceRange;

      if (priceRange && buyingOption.lowestDisplayPrice !== buyingOption.highestDisplayPrice) {
        priceRange = buyingOption.lowestDisplayPrice + ' - ' + buyingOption.highestDisplayPrice;
      }
    }

    // Update pricing
    if (showPricing) {
      this.$pricing.text(priceRange || '');
    } else {
      this.$pricing.addClass(config.classes.uHide);
      this.$costingUnit.addClass(config.classes.uHide);
    }
  },

  setStockForBuyingOption: function(buyingOption) {
    var stock = 0;
    var data;
    if (buyingOption.type === 'AddToCart') {
      if (buyingOption.quantity) {
        stock = buyingOption.displayQuantity;
        data = this.$('.DoubleCtas-item a')[0];
        if (data !== undefined) {
          this.$('.DoubleCtas-item a')[0].setAttribute('aria-label',this.$('.DoubleCtas-item a')[0].getAttribute('aria-label') + ' ' + stock);
        }
      }
    }

    // Update stock
    if (stock) {
      this.$stock.text(stock);
      this.$stockContainer.removeClass(config.classes.uHide);
    } else {
      this.$stockContainer.addClass(config.classes.uHide);
    }
  },

  /**
   * Set data attributes so that the ProductImpression has access to the data
   *
   * @param {BuyingOption} buyingOption
   */
  setProductImpressionDataAttribute: function(buyingOption, isDiscontinued) {
    this.el.dataset.price = (buyingOption.lowestPrice) ? buyingOption.lowestPrice : 0;
    this.el.dataset.sourcePartId = buyingOption.sourcePartId;
    this.el.dataset.sourceCode = buyingOption.sourceCode;
    this.el.dataset.stock = buyingOption.quantity;
    this.el.dataset.quantity = buyingOption.quantity;
    this.el.dataset.packagingType = buyingOption.packagingType;
    this.el.dataset.unitOfMeasure = buyingOption.unitOfMeasure;
    this.el.dataset.isDiscontinued = isDiscontinued;
    this.el.dataset.daysUntilDispatch = buyingOption.daysUntilDispatch;
    this.el.dataset.manufacturerLeadTime = buyingOption.manufacturerLeadTime;
    this.el.dataset.countryCodeName = buyingOption.countryCodeName;




    if (buyingOption.priceBands && buyingOption.priceBands.length > 0) {
      this.el.dataset.hasTieredPricing = buyingOption.priceBands[0].hasTieredPricing;
    }
  },

  updateViewWithPricingData: function(buyingOption, isDiscontinued) {
    this.setButtonForBuyingOption(buyingOption);
    this.setPricingForBuyingOption(buyingOption);
    this.setStockForBuyingOption(buyingOption);
    this.setProductImpressionDataAttribute(buyingOption, isDiscontinued);

    // Update main hiding classes
    this.$loading.removeClass('ProductPricing-loading');
    this.$hidden.removeClass('ProductPricing-hide');
    this.$el.removeClass('ProductPricing');
  }
});

module.exports = ProductPricingView;



// WEBPACK FOOTER //
// ./assets/components/ProductPricing/ProductPricingView.js